<template>
  <div class="schedule-container">

    <header class="page-header">
      <div class="title-row">
        <div class="title-group">
          <i class="bx bx-time header-icon"></i>
          <h1>
            Расписание ТФ НИЯУ МИФИ (преподавателя)
            <span class="tutor-name">{{ tutorNameDisplay }}</span>
          </h1>
        </div>
      </div>
    </header>

    <nav class="tabs-nav">
      <ul>
        <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="{ active: selectedTabId === tab.id }"
          @click="selectTab(tab.id)"
        >
          {{ tab.name }}
        </li>
      </ul>
    </nav>

    <main class="content-area">
      <h2 class="section-title" v-if="!selectedTabId.startsWith('general-')">{{ currentTabName }}</h2>

      <div v-if="selectedTabId === 'today'">
        <div class="schedule-list">
          <div class="day-header">
            <i class="bx bx-chevron-left nav-arrow" @click="changeDate(-1)"></i>
            <span class="date-display">{{ formattedHeaderDate }}</span>
            <i class="bx bx-chevron-right nav-arrow" @click="changeDate(1)"></i>
          </div>

          <div v-if="scheduleStore.loading" class="loading-state">Загрузка...</div>

          <div v-else-if="scheduleStore.todaySchedule && scheduleStore.todaySchedule.length > 0" class="schedule-card">
            <div v-for="(lesson, index) in scheduleStore.todaySchedule" :key="index" class="schedule-row">
              <div class="time-col">
                <span class="time-text">{{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}</span>
                <span
                  class="week-rect"
                  :class="getWeekTypeClass(lesson.weekType)"
                  :title="getWeekTypeText(lesson.weekType)"
                ></span>
              </div>

              <div class="info-col">
                <div class="lesson-title">
                  <span class="span" :class="getSessionClass(lesson.sessionType)"></span>

                  <div class="lesson-meta-group">
                    <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                      {{ getSessionName(lesson.sessionType) }}
                    </span>
                    <span :class="getSessionTextClass(lesson.sessionType)" class="subject-name">
                      {{ lesson.subject ? lesson.subject.name : '' }}
                    </span>
                  </div>

                  <div class="title-teacher" v-if="lesson.group" :class="getSessionTextClass(lesson.sessionType)">
                    <i class="bx bxs-group" style="margin-right: 5px;"></i> {{ lesson.group.name }}
                  </div>
                </div>
              </div>

              <div class="location-col">
                <template v-if="lesson.roomId">
                  <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                  <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                </template>
                <template v-if="lesson.isOnline">
                  <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                    <i class="bx bx-link"></i> Ссылка
                  </a>
                  <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                    ОНЛ
                  </span>
                </template>
              </div>

            </div>
          </div>
          <div v-else class="empty-state"><p>На эту дату занятий нет.</p></div>
        </div>
      </div>

      <div v-else-if="selectedTabId === 'thisweek'">
        <div class="schedule-list">
          <div class="day-header">
            <i class="bx bx-chevron-left nav-arrow" @click="changeWeek(-1)"></i>
            <span class="date-display">{{ formattedWeekRange }}</span>
            <i class="bx bx-chevron-right nav-arrow" @click="changeWeek(1)"></i>
          </div>

          <div v-if="scheduleStore.loading" class="loading-state">Загрузка недели...</div>

          <div v-else-if="groupedWeekSchedule && Object.keys(groupedWeekSchedule).length > 0">
            <div v-for="(dayLessons, dayNum) in groupedWeekSchedule" :key="dayNum" :class="{ disabled: isDisabled(dayNum) }" class="week-day-block">
              <div class="week-day-title">
                {{ getDayNameByNumber(dayNum) }}
              </div>
              <div class="schedule-card-group">
                <div v-for="(lesson, index) in dayLessons" :key="index" class="schedule-row">
                  <div class="time-col">
                    <span class="time-text">{{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}</span>
                    <span class="week-rect" :class="getWeekTypeClass(lesson.weekType)"
                          :title="getWeekTypeText(lesson.weekType)"></span>
                  </div>
                  <div class="info-col">
                    <div class="lesson-title">
                      <span class="span" :class="getSessionClass(lesson.sessionType)"></span>

                      <div class="lesson-meta-group">
                        <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                          {{ getSessionName(lesson.sessionType) }}
                        </span>
                        <span :class="getSessionTextClass(lesson.sessionType)" class="subject-name">
                          {{ lesson.subject ? lesson.subject.name : '' }}
                        </span>
                      </div>

                      <div class="title-teacher" v-if="lesson.group" :class="getSessionTextClass(lesson.sessionType)">
                        <i class="bx bxs-group"></i> {{ lesson.group.name }}
                      </div>
                    </div>
                  </div>

                  <div class="location-col">
                    <template v-if="lesson.roomId">
                      <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                      <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                    </template>
                    <template v-if="lesson.isOnline">
                      <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                        <i class="bx bx-link"></i> Ссылка
                      </a>
                      <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                        ОНЛ
                      </span>
                    </template>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><p>На эту неделю занятий нет.</p></div>
        </div>
      </div>

      <div v-else-if="selectedTabId.startsWith('general-')">
        <div v-if="generalLoading" class="loading-state">Загрузка общего расписания...</div>

        <div v-else-if="Object.keys(groupedGeneralSchedule).length > 0">
          <div v-for="(dayLessons, dayNum) in groupedGeneralSchedule" :key="dayNum" class="week-day-block">
            <div class="week-day-title">
              {{ getDayNameByNumber(dayNum) }}
            </div>
            <div class="schedule-card-group">
              <div v-for="(lesson, index) in dayLessons" :key="index" class="schedule-row">
                <div class="time-col">
                  <span class="time-text">{{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}</span>
                  <span class="week-rect" :class="getWeekTypeClass(lesson.weekType)" :title="getWeekTypeText(lesson.weekType)"></span>
                </div>
                <div class="info-col">
                  <div class="lesson-title">
                    <span class="span" :class="getSessionClass(lesson.sessionType)"></span>

                    <div class="lesson-meta-group">
                        <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                          {{ getSessionName(lesson.sessionType) }}
                        </span>
                      <span :class="getSessionTextClass(lesson.sessionType)" class="subject-name">
                          {{ lesson.subject ? lesson.subject.name : '' }}
                        </span>
                    </div>

                    <div class="title-teacher" v-if="lesson.group" :class="getSessionTextClass(lesson.sessionType)">
                      <i class="bx bxs-group"></i> {{ lesson.group.name }}
                    </div>
                  </div>
                </div>

                <div class="location-col">
                  <template v-if="lesson.roomId">
                    <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                    <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                  </template>
                  <template v-if="lesson.isOnline">
                    <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                      <i class="bx bx-link"></i> Ссылка
                    </a>
                    <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                      ОНЛ
                    </span>
                  </template>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>Расписание отсутствует.</p>
        </div>
      </div>
    </main>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import axios from 'axios';
import { fetchTutorScheduleByDate, fetchTutorWeekSchedule, scheduleStore } from '@/store/schedule';
import { API_URL } from '../server';

const instance = getCurrentInstance();
const route = (instance && instance.proxy) ? instance.proxy.$route : null;
const API_BASE_URL = API_URL;

const selectedTabId = ref("today");
const currentTutorId = ref(null);
const currentDate = ref(new Date());
const weekOffset = ref(0);
const todayDay = getDayOfWeekUTCPlus5();
const generalScheduleData = ref([]);
const generalLoading = ref(false);

const tabs = [
  { id: "general-every", name: "Все недели" },
  { id: "general-upper", name: "Верхняя неделя" },
  { id: "general-lower", name: "Нижняя неделя" },
  { id: "today", name: "Текущий день" },
  { id: "thisweek", name: "Текущая неделя" },
];

// --- MAPPING HELPERS ---
const getSessionName = function(type) {
  var names = { 1: '', 2: 'ЛЕК', 3: 'ПР', 4: 'ЛАБ', 5: 'ПЕРЕ', 6: 'ЭКЗ', 7: 'КОМ', 8: 'ЗАЧ' };
  return names[type] || '---';
};

const getSessionClass = function(type) {
  var classes = { 1: '', 2: 'badge-lecture', 3: 'badge-practice', 4: 'badge-lab', 5: 'badge-retake', 6: 'badge-exam', 7: 'badge-commission', 8: 'badge-credit' };
  return classes[type] || 'badge-default';
};

const getSessionTextClass = function(type) {
  var classes = { 1: 'text-default', 2: 'text-lecture', 3: 'text-practice', 4: 'text-lab', 5: 'text-retake', 6: 'text-exam', 7: 'text-commission', 8: 'text-credit' };
  return classes[type] || 'text-default';
};

const getWeekTypeClass = function(type) {
  if (type === 1) return 'week-every';
  if (type === 2) return 'week-upper';
  if (type === 3) return 'week-lower';
  return '';
};

const getWeekTypeText = function(type) {
  if (type === 1) return 'Каждую неделю';
  if (type === 2) return 'Верхняя неделя';
  if (type === 3) return 'Нижняя неделя';
  return '';
};

// --- LOGIC ---
const tutorName = computed(function() {
  var sources = [scheduleStore.todaySchedule, scheduleStore.weekSchedule, generalScheduleData.value];
  for (var i = 0; i < sources.length; i++) {
    var src = sources[i];
    if (src && src.length > 0 && src[0].tutor) return src[0].tutor.name;
  }
  return '...';
});

// *** FIXED SORTING FOR GENERAL SCHEDULE ***
const groupedGeneralSchedule = computed(function() {
  var list = generalScheduleData.value || [];
  var groups = {};

  list.forEach(function(lesson) {
    if (lesson.isDeleted) return; // ignore deleted
    var day = lesson.dayOfWeek;
    if (!groups[day]) groups[day] = [];
    groups[day].push(lesson);
  });

  var sorted = {};
  // Sort days 1..7
  Object.keys(groups).sort(function(a,b){ return Number(a)-Number(b) }).forEach(function(key) {
    // Sort lessons by startTime
    sorted[key] = groups[key].sort(function(a,b){
      return (a.startTime||'').localeCompare(b.startTime||'');
    });
  });
  return sorted;
});

// *** FIXED SORTING FOR THIS WEEK (Group by dayOfWeek) ***
const groupedWeekSchedule = computed(function() {
  var list = scheduleStore.weekSchedule || [];
  var groups = {};

  list.forEach(function(lesson) {
    if (lesson.isDeleted) return;
    // Use dayOfWeek as key (1-7)
    var dayNum = lesson.dayOfWeek;
    if (!groups[dayNum]) groups[dayNum] = [];
    groups[dayNum].push(lesson);
  });

  var sorted = {};
  // Sort days 1..7
  Object.keys(groups).sort(function(a,b){ return Number(a)-Number(b) }).forEach(function(key) {
    // Sort lessons by startTime
    sorted[key] = groups[key].sort(function(a,b){
      return (a.startTime||'').localeCompare(b.startTime||'');
    });
  });
  return sorted;
});

const selectTab = function(id) {
  selectedTabId.value = id;
  if (!currentTutorId.value) return;
  if (id === 'today') {
    currentDate.value = new Date();
    fetchTutorScheduleByDate(currentTutorId.value);
  } else if (id === 'thisweek') {
    fetchTutorWeekSchedule(currentTutorId.value, weekOffset.value);
  } else if (id.startsWith('general-')) {
    fetchGeneralTutorSchedule(id.replace('general-', ''));
  }
};

const fetchGeneralTutorSchedule = async function(type) {
  generalLoading.value = true;
  generalScheduleData.value = [];
  var endpoint = '/api/schedule/get-tutor-every-weeks';
  if (type === 'upper') endpoint = '/api/schedule/get-tutor-upper-weeks';
  if (type === 'lower') endpoint = '/api/schedule/get-tutor-lower-weeks';
  try {
    var res = await axios.get(API_BASE_URL + endpoint + '?tutorId=' + currentTutorId.value);
    if (res.data && res.data.code === 200) generalScheduleData.value = res.data.data;
  } catch (e) { console.error(e); }
  finally { generalLoading.value = false; }
};

const changeDate = async function(offset) {
  var d = new Date(currentDate.value);
  d.setDate(d.getDate() + offset);
  currentDate.value = d;
  var apiStr = d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  await fetchTutorScheduleByDate(currentTutorId.value, apiStr);
};

const changeWeek = async function(offset) {
  weekOffset.value += offset;
  await fetchTutorWeekSchedule(currentTutorId.value, weekOffset.value);
};

const tutorNameDisplay = computed(() => {
  // 1. Try to get from URL Query (Immediate)
  if (route && route.query && route.query.tutorTitle) {
    return route.query.tutorTitle;
  }

  return '...';
});


onMounted(function() {
  if (route && route.params && route.params.id) {
    currentTutorId.value = route.params.id;
    fetchTutorScheduleByDate(currentTutorId.value);
  }
});

function formatDateRu(d) {
  var date = new Date(d);
  return String(date.getDate()).padStart(2,'0')+'-'+String(date.getMonth()+1).padStart(2,'0')+'-'+date.getFullYear();
}

function getDayName(d) {
  return ['ВОСКРЕСЕНЬЕ','ПОНЕДЕЛЬНИК','ВТОРНИК','СРЕДА','ЧЕТВЕРГ','ПЯТНИЦА','СУББОТА'][new Date(d).getDay()];
}

const getDayNameByNumber = function(n) {
  return ['', 'ПОНЕДЕЛЬНИК', 'ВТОРНИК', 'СРЕДА', 'ЧЕТВЕРГ', 'ПЯТНИЦА', 'СУББОТА', 'ВОСКРЕСЕНЬЕ'][n] || '---';
};

const formatTime = function(t) { return t ? t.slice(0, 5) : ''; };
const formattedHeaderDate = computed(function() { return getDayName(currentDate.value) + ' , ' + formatDateRu(currentDate.value); });
const formattedWeekRange = computed(function() {
  var now = new Date();
  var day = now.getDay() || 7;
  var mon = new Date(now);
  mon.setDate(now.getDate() - (day - 1) + (weekOffset.value * 7));
  var sun = new Date(mon); sun.setDate(mon.getDate() + 6);
  return formatDateRu(mon) + ' — ' + formatDateRu(sun);
});

function getDayOfWeekUTCPlus5() {
  const now = new Date();
  const utcPlus5 = new Date(now.getTime() + 5 * 60 * 60 * 1000);
  const utcDay = utcPlus5.getUTCDay();
  return utcDay === 0 ? 7 : utcDay;
}

function isDisabled(dayNum) {
  if(weekOffset >= 1) {
    return dayNum < todayDay;
  }

  return false;
}

const currentTabName = computed(function() { return (tabs.find(function(t){return t.id === selectedTabId.value}) || {}).name || ''; });
</script>

<style scoped>
/* GENERAL STRUCTURE */
.schedule-container {
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
}

/* HEADER */
.page-header { margin-bottom: 25px; }
.title-row { display: flex; justify-content: space-between; align-items: center; }
.title-group { display: flex; align-items: center; gap: 15px; }
.header-icon { font-size: 28px; color: #0e7490; }
.title-group h1 { font-weight: 300; font-size: 24px; color: #333; margin: 0; line-height: 1.2; }
.tutor-name { display: block; font-weight: 600; color: #0e7490; font-size: 1.1em; }

/* TABS NAVIGATION */
.tabs-nav { margin-bottom: 20px; }
.tabs-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  border-bottom: 2px solid #e5e7eb;
}
.tabs-nav li {
  padding: 12px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #64748b;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap; /* Prevent line breaks within tab */
}
.tabs-nav li.active {
  color: #0e7490;
  font-weight: bold;
  border-bottom: 2px solid #0e7490;
  margin-bottom: -2px; /* Overlap border */
}
.tabs-nav li:hover:not(.active) { color: #334155; }

/* MAIN CONTENT */
.section-title { font-size: 20px; color: #333; margin-bottom: 15px; display: none; /* Often redundant with tabs */ }

/* DATE/WEEK NAVIGATOR */
.day-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f1f5f9;
  padding: 15px 20px;
  border-bottom: 1px solid #e2e8f0;
  color: #475569;
}
.nav-arrow { font-size: 36px; cursor: pointer; color: #64748b; transition: color 0.2s; }
.nav-arrow:hover { color: #0e7490; }
.date-display { font-weight: 700; font-size: 18px; text-transform: uppercase; text-align: center; }

/* SCHEDULE LIST & ROWS (DESKTOP DEFAULT) */
.schedule-list {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin-bottom: 20px;
}
.schedule-row {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  padding: 16px 24px;
  align-items: center;
  transition: background-color 0.1s;
}
.schedule-row:last-child { border-bottom: none; }
.schedule-row:hover { background-color: #f8fafc; }

/* COLUMNS */
.time-col {
  width: 160px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.time-text { font-size: 15px; }
.info-col { flex: 1; padding: 0 15px; }
.location-col {
  width: 350px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  color: #475569;
  font-weight: 600;
}

/* LESSON INFO */
.lesson-title { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.lesson-meta-group { display: flex; align-items: center; gap: 8px; flex-wrap: wrap;} /* Groups badge + subject */
.subject-name { font-weight: 600; font-size: 15px; }
.title-teacher {
  font-weight: 400;
  color: #64748b;
  font-size: 14px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

/* STATES */
.loading-state, .empty-state { padding: 50px 20px; text-align: center; color: #64748b; background: #f8fafc; }
.week-day-block { margin-bottom: 30px; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; background: white; }
.week-day-title {
  background-color: #e0f2fe;
  color: #0369a1;
  padding: 12px 24px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e0f2fe;
}
.week-day-block.disabled { opacity: 0.5; pointer-events: none; filter: grayscale(100%); }

/* BADGES & DECORATION */
.span { width: 4px; height: 28px; display: inline-block; border-radius: 2px; flex-shrink: 0; }
.span_title {
  color: white; padding: 3px 8px; border-radius: 4px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  min-width: 40px; text-align: center; display: inline-block;
}
.week-rect {
  width: 14px; height: 14px; border: 1px solid #d4d4d8;
  border-radius: 2px; flex-shrink: 0;
}
.week-every { background-color: #facc15; border-color: #eab308; }
.week-upper { background: linear-gradient(to bottom, #facc15 50%, white 50%); border-color: #eab308; }
.week-lower { background: linear-gradient(to top, #facc15 50%, white 50%); border-color: #eab308; }

/* SESSION COLORS */
.badge-lecture { background-color: #15803d; }
.badge-practice { background-color: #be123c; }
.badge-lab { background-color: #b45309; }
.badge-retake { background-color: #333; }
.badge-exam { background-color: #b91c1c; }
.badge-commission { background-color: #000; }
.badge-credit { background-color: #7c3aed; }
.badge-default { background-color: #64748b; }

.text-lecture { color: #15803d !important; }
.text-practice { color: #be123c !important; }
.text-lab { color: #b45309 !important; }
.text-retake { color: #333 !important; }
.text-exam { color: #b91c1c !important; }
.text-commission { color: #000 !important; }
.text-credit { color: #7c3aed !important; }

/* ONLINE LINK STYLES */
.online-link {
  display: flex;
  align-items: center;
  color: #0e7490;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  background-color: #e0f2fe;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.online-link:hover {
  background-color: #bae6fd;
  text-decoration: underline;
}

.online-link i {
  font-size: 18px;
  margin-right: 4px;
}


/* =========================================
   MOBILE RESPONSIVENESS (Max-width 768px)
   ========================================= */
@media (max-width: 768px) {
  .schedule-container { padding: 10px; }

  /* Allow tabs to scroll horizontally */
  .tabs-nav ul {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scroll on iOS */
    padding-bottom: 5px; /* Space for scrollbar */
  }
  .tabs-nav li { padding: 10px 15px; font-size: 14px; }
  /* Hide scrollbar for Chrome/Safari/Opera */
  .tabs-nav ul::-webkit-scrollbar { display: none; }
  /* Hide scrollbar for IE, Edge and Firefox */
  .tabs-nav ul { -ms-overflow-style: none;  scrollbar-width: none;  }

  /* Header adjustments */
  .title-group h1 { font-size: 18px; }
  .header-icon { font-size: 24px; }

  /* Date Header */
  .day-header { padding: 10px 15px; }
  .nav-arrow { font-size: 32px; }
  .date-display { font-size: 14px; }

  /* STACK COLUMNS FOR MOBILE CARDS */
  .schedule-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
    gap: 8px;
    position: relative;
  }

  /* Time row on top */
  .time-col {
    width: 100%;
    margin-bottom: 5px;
    justify-content: flex-start;
    font-size: 14px;
    color: #64748b;
  }
  /* Rect indicator right next to time */
  .week-rect { width: 12px; height: 12px; margin-left: 8px; }

  /* Info takes middle */
  .info-col { width: 100%; padding: 0; }
  .lesson-title { align-items: flex-start; } /* Align color strip to top of text */
  .lesson-meta-group { display: block; } /* Stack Badge and Subject name if needed, or keep inline */
  .subject-name { display: block; line-height: 1.3; margin-top: 2px; }

  .span { height: auto; align-self: stretch; min-height: 30px; margin-right: 10px; } /* Strip spans full height */
  .span_title { display: inline-block; margin-bottom: 4px; }

  .title-teacher {
    margin-top: 5px;
    margin-left: 0; /* Align with text, not strip */
    font-size: 13px;
    width: 100%;
  }

  /* Location at bottom */
  .location-col {
    width: 100%;
    justify-content: flex-start;
    margin-top: 5px;
    padding-left: 15px; /* Indent to match text (after strip) */
    font-size: 14px;
    color: #64748b;
  }

  /* Week blocks */
  .week-day-title { font-size: 13px; padding: 10px 15px; }
}
</style>
